module.exports = __webpack_public_path__ + "img/linkface.e0f5400e.svg";